module.exports = __webpack_public_path__ + "static/img/Hugh-McCluggage.61ad83b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hugh-McCluggage.jpg
// module id = jCv9
// module chunks = 0